module.exports = __webpack_public_path__ + "img/product-preview-21.4f42534.png";